module.exports = __webpack_public_path__ + "static/media/RepiSkWhite.309d95e3.svg";